import React from "react";

import { MenuRounded, RefreshRounded } from "@mui/icons-material";
import PostAddIcon from "@mui/icons-material/PostAdd";
import { Box, Skeleton } from "@mui/material";
import { DateTime } from "luxon";

import useFirebase from "../../../config/context/firebaseContext";
import useMainState from "../../../config/context/mainStateContext";
import useModal from "../../../config/context/modalContext";
import { SpottService } from "../../../config/services/SpottService";

import MainBorderButton from "../../../components/MainBorderButton";
import MainConfigBanner from "../../../components/MainConfigBanner";
import MainText from "../../../components/MainText";
import ModalSpottCreate from "../../../components/ModalSpottCreate";
import PageHeader from "../../../components/PageHeader";
import SpottPost from "../../../components/SpottPost";

export default function SpottTab() {
  const { getConfig, analyticLog } = useFirebase();
  const { pushAlert } = useModal();
  const { setShowSideMenuDrawer, userEnableToInteract } = useMainState();
  const SpottList = !getConfig("enabled_user_spott_filter")
    ? SpottService.LazyList()
    : SpottService.ListLast();

  const timestampDay = DateTime.now().startOf("day").toMillis();
  const timestampYesterday = DateTime.now().minus({ day: 1 }).startOf("day").toMillis();
  const timestampWeek = DateTime.now().minus({ days: 7 }).startOf("day").toMillis();

  const [timestampFilter, setTimestampFilter] = React.useState(timestampDay);
  const [showModalCreate, setShowModalCreate] = React.useState(false);

  const handleSendSpottClick = () => {
    if (userEnableToInteract()) setShowModalCreate(true);
  };

  const loadSpotts = async () => {
    SpottList.runRequest(
      !getConfig("enabled_user_spott_filter")
        ? undefined
        : parseInt(String(getConfig("number_spott_posts")))
    ).catch((err) =>
      pushAlert({ type: "error", message: "Erro ao buscar postagens. " + err.message })
    );
  };

  React.useEffect(() => {
    loadSpotts();
  }, [timestampFilter]);

  React.useEffect(() => {
    analyticLog("click_spott_tab");
  }, []);

  return (
    <Box>
      <PageHeader
        title="Spott"
        leftIcon={<MenuRounded />}
        onLeftAction={() => setShowSideMenuDrawer(true)}
        rightIcon={<RefreshRounded />}
        onRightAction={() => loadSpotts()}
      />

      {showModalCreate && <ModalSpottCreate onClose={() => setShowModalCreate(false)} />}

      {getConfig("enabled_send_spott") ? (
        <Box mb={4}>
          <MainBorderButton
            text="Enviar Spott"
            icon={<PostAddIcon />}
            onClick={handleSendSpottClick}
          />
        </Box>
      ) : null}

      <MainConfigBanner screen="spott" />

      {/* {!getConfig("enabled_user_spott_filter") ? (
        <Box mb={4} gap={1} display={"flex"}>
          <ChipMain
            options={[
              { name: "Hoje", value: timestampDay },
              { name: "Ontem", value: timestampYesterday },
              { name: "Última Semana", value: timestampWeek },
            ]}
            onChange={(value) => setTimestampFilter(value as number)}
            value={timestampFilter}
          />
        </Box>
      ) : null} */}

      {SpottList?.items && SpottList?.items?.map((item) => <SpottPost item={item} key={item.id} />)}

      {SpottList.isLoading && SpottList?.items?.length === 0 && (
        <>
          <Skeleton
            animation="wave"
            variant="rounded"
            width={"100%"}
            height={120}
            sx={{ mb: 2, borderRadius: "15px", mt: 2 }}
          />

          <Skeleton
            animation="wave"
            variant="rounded"
            width={"100%"}
            height={150}
            sx={{ mb: 2, borderRadius: "15px" }}
          />
        </>
      )}

      {SpottList?.items?.length === 0 && !SpottList.isLoading && (
        <MainText size="caption" color="regular">
          Nenhuma postagem encontrada...
        </MainText>
      )}

      {(SpottList as any)?.hasMore ? (
        <Box my={4}>
          <MainBorderButton
            onClick={loadSpotts}
            loading={SpottList.isLoading}
            text="Carregar Mais"
          />
        </Box>
      ) : null}

      {/* <Box my={4}>
        <MainSolidButton text="Carregar Mais" icon={<KeyboardArrowDownIcon />} />
      </Box> */}
    </Box>
  );
}
